export default __webpack_public_path__ + "static/sepoy-51123f9130945b80c325d9c73614bc3a.png";